export const draftEntityTransformer = (
  entity: { type: string; data: { type: 'string'; url: string; targetOption: string } },
  content: string
): string | undefined => {
  switch (entity.type) {
    case 'LINK':
      return `<a href="${entity.data.url}" target="${entity.data.targetOption}">${content}</a>`;
  }
};
